/* ═══════════════════════════════════
   NAMLA JEWELRY — THEME JAVASCRIPT
   ═══════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── STICKY NAV ── */
  const navbar = document.getElementById('navbar');
  window.addEventListener('scroll', () => {
    navbar?.classList.toggle('scrolled', window.scrollY > 50);
  });

  /* ── MOBILE MENU ── */
  const mobileBtn = document.querySelector('.nav-mobile-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  mobileBtn?.addEventListener('click', () => {
    const open = mobileMenu.classList.toggle('open');
    mobileBtn.setAttribute('aria-expanded', open);
    mobileMenu.setAttribute('aria-hidden', !open);
  });

  /* ── SEARCH OVERLAY ── */
  const searchBtn = document.querySelector('.nav-search-btn');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose = document.querySelector('.search-close');
  searchBtn?.addEventListener('click', () => {
    searchOverlay.classList.add('open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchOverlay.querySelector('.search-input')?.focus();
  });
  searchClose?.addEventListener('click', () => {
    searchOverlay.classList.remove('open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      searchOverlay?.classList.remove('open');
      cartDrawer?.setAttribute('aria-hidden', 'true');
    }
  });

  /* ── CART DRAWER ── */
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerBody = document.getElementById('cart-drawer-body');
  const cartCountEl = document.getElementById('cart-count');
  const cartSubtotalEl = document.getElementById('cart-subtotal-price');

  function openCartDrawer() {
    cartDrawer?.setAttribute('aria-hidden', 'false');
    fetchCart();
  }
  function closeCartDrawer() {
    cartDrawer?.setAttribute('aria-hidden', 'true');
  }

  document.querySelector('.nav-cart-btn')?.addEventListener('click', openCartDrawer);
  document.querySelector('.cart-drawer__close')?.addEventListener('click', closeCartDrawer);
  document.querySelector('.cart-drawer__overlay')?.addEventListener('click', closeCartDrawer);

  /* ── FETCH CART ── */
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartUI(cart);
    } catch (err) {
      console.error('Cart fetch error', err);
    }
  }

  function updateCartUI(cart) {
    if (cartCountEl) {
      cartCountEl.textContent = cart.item_count;
      cartCountEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
    if (cartSubtotalEl) {
      cartSubtotalEl.textContent = formatMoney(cart.total_price);
    }
    if (cartDrawerBody) {
      if (cart.item_count === 0) {
        cartDrawerBody.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
        return;
      }
      cartDrawerBody.innerHTML = cart.items.map(item => `
        <div class="cart-drawer-item">
          <img src="${item.image}" alt="${item.title}" loading="lazy">
          <div class="cart-drawer-item__info">
            <p class="cart-drawer-item__name">${item.product_title}</p>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:0.7rem;color:var(--text-muted)">${item.variant_title}</p>` : ''}
            <p style="font-size:0.7rem;margin-top:4px;">Qty: ${item.quantity}</p>
            <p class="cart-drawer-item__price">${formatMoney(item.line_price)}</p>
          </div>
        </div>
      `).join('');
    }
  }

  /* ── ADD TO CART ── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.btn-add-to-cart');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const qtyInput = document.getElementById('quantity');
    const quantity = qtyInput ? parseInt(qtyInput.value) : 1;

    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      const item = await res.json();
      if (item.status) throw new Error(item.description);

      btn.textContent = 'Added!';
      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 1500);

      await fetchCart();
      openCartDrawer();
    } catch (err) {
      btn.textContent = 'Error';
      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 2000);
      console.error('Add to cart error:', err);
    }
  });

  /* ── WISHLIST (localStorage) ── */
  const wishlist = JSON.parse(localStorage.getItem('namla_wishlist') || '[]');

  document.querySelectorAll('.product-wish').forEach(btn => {
    const productId = btn.dataset.productId;
    if (wishlist.includes(productId)) {
      btn.textContent = '♥';
      btn.style.color = 'var(--gold)';
    }
    btn.addEventListener('click', () => {
      const idx = wishlist.indexOf(productId);
      if (idx > -1) {
        wishlist.splice(idx, 1);
        btn.textContent = '♡';
        btn.style.color = '';
      } else {
        wishlist.push(productId);
        btn.textContent = '♥';
        btn.style.color = 'var(--gold)';
      }
      localStorage.setItem('namla_wishlist', JSON.stringify(wishlist));
    });
  });

  /* ── SCROLL FADE-IN ── */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .testimonial-card, .collection-card, .process-step').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
    observer.observe(el);
  });

  /* ── CART QTY BUTTONS (cart page) ── */
  document.querySelectorAll('.cart-qty-minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector(`.qty-input[data-line="${btn.dataset.line}"]`);
      if (input && parseInt(input.value) > 0) {
        input.value = parseInt(input.value) - 1;
      }
    });
  });
  document.querySelectorAll('.cart-qty-plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = document.querySelector(`.qty-input[data-line="${btn.dataset.line}"]`);
      if (input) input.value = parseInt(input.value) + 1;
    });
  });

  /* ── UTILITIES ── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ── INIT CART COUNT ── */
  fetchCart();

});
